"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryNameValidateComponent = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var SummaryNameValidateComponent = /** @class */ (function (_super) {
    __extends(SummaryNameValidateComponent, _super);
    function SummaryNameValidateComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            policyHolder: null,
            nameEditPopupOpen: false,
            policyHolderNameValid: (0, commonFunctions_1.isPolicyHolderNameValid)(_this.props.policyHolder)
        };
        _this.handleFullNameChange = _this.handleFullNameChange.bind(_this);
        _this.toggleEditFullNamePopup = _this.toggleEditFullNamePopup.bind(_this);
        _this.renderFullNameEditPopup = _this.renderFullNameEditPopup.bind(_this);
        _this.saveAndConfirm = _this.saveAndConfirm.bind(_this);
        _this.openEditNamePopup = _this.openEditNamePopup.bind(_this);
        return _this;
    }
    SummaryNameValidateComponent.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key policy-holder-name mb-2 ".concat(this.state.policyHolderNameValid ? "" : "text-danger ") },
                    this.props.policyHolder.firstName,
                    " ",
                    this.props.policyHolder.lastName)),
            !this.state.policyHolderNameValid &&
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("span", { className: "text-danger " }, "Your name appears to contain special characters that we don't accept.")),
                    React.createElement("div", { className: "edit-phone-number mt-2" },
                        React.createElement("button", { className: "link-edit", onClick: this.toggleEditFullNamePopup }, "Please update your name"))),
            this.state.nameEditPopupOpen && this.renderFullNameEditPopup()));
    };
    SummaryNameValidateComponent.prototype.renderFullNameEditPopup = function () {
        var title = "Update your name";
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleEditFullNamePopup });
        return (React.createElement(reactstrap_1.Modal, { className: "edit-name-modal my-2 info-modal", isOpen: this.state.nameEditPopupOpen, toggle: this.toggleEditFullNamePopup, close: closeBtn },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleEditFullNamePopup },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block warning-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, title))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                React.createElement("div", { className: "mb-3" },
                    React.createElement("p", { className: "m-0" }, "Your name appears to contain special characters that we don't accept. Please update your name below")),
                React.createElement("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "font-weight-bold" }, "First name")),
                    React.createElement("div", { className: "col-md-7 d-flex p-0" },
                        React.createElement("input", { onChange: this.handleFullNameChange, type: "text", className: "form-control", id: "firstNameChange" }))),
                React.createElement("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "font-weight-bold" }, "Last name")),
                    React.createElement("div", { className: "col-md-7 d-flex p-0" },
                        React.createElement("input", { onChange: this.handleFullNameChange, type: "text", className: "form-control" })))),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides" },
                React.createElement("button", { type: "button", className: "btn btn-primary ".concat(this.state.policyHolderNameValid ? "" : "btn-disabled ", " btn-next-arrow-separate width-md-250"), onClick: this.saveAndConfirm }, "Save and continue"),
                React.createElement("button", { type: "button", className: "btn btn-back width-md-250", onClick: this.toggleEditFullNamePopup }, "Cancel"))));
    };
    SummaryNameValidateComponent.prototype.openEditNamePopup = function () {
        this.setState(function (prevState) { return ({
            nameEditPopupOpen: !prevState.nameEditPopupOpen
        }); });
    };
    SummaryNameValidateComponent.prototype.toggleEditFullNamePopup = function () {
        var _this = this;
        this.setState(function (prevState) { return ({
            nameEditPopupOpen: !prevState.nameEditPopupOpen,
            policyHolderNameValid: (0, commonFunctions_1.isPolicyHolderNameValid)(_this.props.policyHolder)
        }); });
    };
    SummaryNameValidateComponent.prototype.handleFullNameChange = function (event) {
        var policyHolder = __assign({}, this.state.policyHolder);
        if (event.target.id === "firstNameChange") {
            policyHolder.firstName = event.target.value;
        }
        else {
            policyHolder.lastName = event.target.value;
        }
        if ((0, commonFunctions_1.isPolicyHolderNameValid)(policyHolder)) {
            this.setState({
                policyHolderNameValid: true,
                policyHolder: policyHolder
            });
        }
    };
    ;
    SummaryNameValidateComponent.prototype.saveAndConfirm = function () {
        this.props.onStateChange("policyHolder.firstName", this.state.policyHolder.firstName);
        this.props.onStateChange("policyHolder.lastName", this.state.policyHolder.lastName);
        this.toggleEditFullNamePopup();
    };
    return SummaryNameValidateComponent;
}(React.Component));
exports.SummaryNameValidateComponent = SummaryNameValidateComponent;
//# sourceMappingURL=SummaryNameValidateComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/annual/SummaryNameValidateComponent.js
// module id = 3685
// module chunks = 0